export const environment = {
  production: false,
  apiUrl: 'https://rieayaapi.20.197.55.96.nip.io',
  baseUrl: 'https://rieayaapi.20.197.55.96.nip.io/',
  googleMapsApiKey: 'AIzaSyBDyrO3M9CjwO6YaMuivp4xHInNKu3ykDA',
  LoginSSOROP: '',
  appTitleAr: 'رعاية - لوحة المتجر',
  appTitleEn: 'Rieaya - Store Panel',
};
